import React from "react";
import OverlayB from "../../common/OverlayB";

function AboutSection({ onClose, open }) {
  return (
    <div
      className="bg-primary relative transition-transform duration-700
        text-white rounded-lg  w-1/2 h-64 flex items-center p-5 flex-col"
      style={{
        height: "50%",
        transform: open ? "translateX(0)" : "translateX(100vw)",
      }}
    >
      <div
        onClick={() => onClose()}
        style={{ right: "0px", top: "0px" }}
        className="bg-red-500 rounded text-white h-8
         cursor-pointer hover:bg-red-600 w-8 flex
         justify-center items-center absolute right-0"
      >
        <span className="fa fa-times"></span>
      </div>
      {/* <div className=" my-5 flex justify-center items-center">
        <span className="text-4xl font-black reflaect">من نحن ؟</span>
      </div> */}
      <div className="flex items-center justify-between w-full flex-1 h-full">
        <div className="flex-1 flex justify-center flex-col items-center">
          <div className="w-32 h-32 rounded-full  shadow-btn flex justify-center items-center ">
            <img
              src={require("../../assest/about/ahmed.png")}
              className="w-full "
              style={{ width: "100%" }}
              alt=""
            />
          </div>
          <div className="flex  text-xl items-center opacity-1  w-32 justify-between mt-10">
            <a className="cursor-pointer fab fa-twitter opacity-25  hover:opacity-100 transition-colors duration-150"></a>
            <a
              target="_blank"
              href="https://www.instagram.com/amedo_o/"
              className="cursor-pointer fab fa-instagram opacity-25  hover:opacity-100  transition-colors duration-150"
            ></a>
            <a className="cursor-pointer fab fa-linkedin opacity-25  hover:opacity-100  transition-colors duration-150"></a>
            <a
              href="mailto:ahmediiv198@gmail.com"
              className="cursor-pointer fas fa-at opacity-25  hover:opacity-100  transition-colors duration-150"
            ></a>
          </div>
        </div>

        <div className="flex-1 flex justify-center flex-col items-center">
          <div className="w-32 h-32 rounded-full    shadow-btn flex justify-center items-center ">
            <img
              src={require("../../assest/about/Mohammedw.png")}
              className="w-8/12"
              alt=""
            />
          </div>
          <div className="flex  text-xl items-center  w-32 justify-between mt-10">
            <a
              target="_blank"
              href="https://twitter.com/Moomood85"
              className="cursor-pointer fab fa-twitter  opacity-25 hover:opacity-100 transition-all duration-150"
            ></a>
            <a
              target="_blank"
              href="https://www.instagram.com/mohamd.js/"
              className="cursor-pointer fab fa-instagram opacity-25  hover:opacity-100  transition-all duration-150"
            ></a>
            <a
              target="_blank"
              href="https://www.linkedin.com/in/mohammed-bin-taleb-2123111b5/"
              className="cursor-pointer fab fa-linkedin  opacity-25 hover:opacity-100  transition-all duration-150"
            ></a>
            <a
              href="mailto:moomood85@gmail.com"
              className="cursor-pointer fas fa-at opacity-25  hover:opacity-100  transition-colors duration-150"
            ></a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default OverlayB(AboutSection);
